import styled from 'styled-components';

const ImageWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: #1a202c;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ImgElement = styled.img`
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
`;

const FloatToolbar = styled.div`
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    padding: 6px 12px;
    background: rgba(20, 22, 28, 0.85);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 30px;
    z-index: 10;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.35);
`;

const RoundButton = styled.button`
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.8);
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.15);
        color: #fff;
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.95);
    }
`;

export function Image({ url }) {
    return (
        <ImageWrapper>
            <ImgElement 
                src={url} 
                alt="Tutorial"
                onError={(e) => {
                    console.error('TUTORIAL DEBUG - Erro ao carregar imagem:', url);
                }}
            />
        </ImageWrapper>
    );
}